export default __webpack_public_path__ + "static/Studio-to-Sea-Homepage-Banner-Mobile-3cc595747e27e637df121a9f33530f67.webp";